/**
 * @generated SignedSource<<cdb0503e16e3ea6bd3ec4c381a0faa1a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type mrrPage_Query$variables = {
  from?: string | null | undefined;
  to?: string | null | undefined;
};
export type mrrPage_Query$data = {
  readonly mrr: {
    readonly activeCustomers: ReadonlyArray<{
      readonly month: string;
      readonly value: number | null | undefined;
    }>;
    readonly arpu: ReadonlyArray<{
      readonly month: string;
      readonly value: number | null | undefined;
    }>;
    readonly churnedMrr: ReadonlyArray<{
      readonly month: string;
      readonly value: number | null | undefined;
    }>;
    readonly contractionMrr: ReadonlyArray<{
      readonly month: string;
      readonly value: number | null | undefined;
    }>;
    readonly endingMrr: ReadonlyArray<{
      readonly month: string;
      readonly value: number | null | undefined;
    }>;
    readonly expansionMrr: ReadonlyArray<{
      readonly month: string;
      readonly value: number | null | undefined;
    }>;
    readonly grrTtm: ReadonlyArray<{
      readonly month: string;
      readonly value: number | null | undefined;
    }>;
    readonly netNewMrr: ReadonlyArray<{
      readonly month: string;
      readonly value: number | null | undefined;
    }>;
    readonly newCustomers: ReadonlyArray<{
      readonly month: string;
      readonly value: number | null | undefined;
    }>;
    readonly newMrr: ReadonlyArray<{
      readonly month: string;
      readonly value: number | null | undefined;
    }>;
    readonly nrrTtm: ReadonlyArray<{
      readonly month: string;
      readonly value: number | null | undefined;
    }>;
    readonly oneTimeRevenue: ReadonlyArray<{
      readonly month: string;
      readonly value: number | null | undefined;
    }>;
    readonly quickRatio: ReadonlyArray<{
      readonly month: string;
      readonly value: number | null | undefined;
    }>;
    readonly reactivationMrr: ReadonlyArray<{
      readonly month: string;
      readonly value: number | null | undefined;
    }>;
    readonly smsRevenue: ReadonlyArray<{
      readonly month: string;
      readonly value: number | null | undefined;
    }>;
  };
  readonly unitEconomics: {
    readonly arpu: number | null | undefined;
    readonly cacPaybackCohortCurves: ReadonlyArray<{
      readonly label: string;
      readonly points: ReadonlyArray<{
        readonly month: string;
        readonly value: number | null | undefined;
      }>;
      readonly size: number;
    }>;
    readonly cacPaybackCohorts: {
      readonly monthly: ReadonlyArray<{
        readonly label: string;
        readonly paybackMonths: number | null | undefined;
      }>;
      readonly quarterly: ReadonlyArray<{
        readonly label: string;
        readonly paybackMonths: number | null | undefined;
      }>;
      readonly yearly: ReadonlyArray<{
        readonly label: string;
        readonly paybackMonths: number | null | undefined;
      }>;
    };
    readonly cacPaybackSeries: {
      readonly punctual: ReadonlyArray<{
        readonly month: string;
        readonly value: number | null | undefined;
      }>;
      readonly ttm: ReadonlyArray<{
        readonly month: string;
        readonly value: number | null | undefined;
      }>;
    };
    readonly cacTtm: number | null | undefined;
    readonly churnCohortCurves: ReadonlyArray<{
      readonly label: string;
      readonly points: ReadonlyArray<{
        readonly month: string;
        readonly value: number | null | undefined;
      }>;
      readonly size: number;
    }>;
    readonly cohortCurves: ReadonlyArray<{
      readonly label: string;
      readonly points: ReadonlyArray<{
        readonly month: string;
        readonly value: number | null | undefined;
      }>;
      readonly size: number;
    }>;
    readonly conversionCohortCurves: ReadonlyArray<{
      readonly label: string;
      readonly points: ReadonlyArray<{
        readonly month: string;
        readonly value: number | null | undefined;
      }>;
      readonly size: number;
    }>;
    readonly grossMarginTtm: number | null | undefined;
    readonly ltv: number | null | undefined;
    readonly ltvToCac: number | null | undefined;
    readonly monthlyRevenueChurnTtm: number | null | undefined;
    readonly paybackMonths: number | null | undefined;
  };
};
export type mrrPage_Query = {
  response: mrrPage_Query$data;
  variables: mrrPage_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "from"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "to"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "arpu",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "grossMarginTtm",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "monthlyRevenueChurnTtm",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ltv",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cacTtm",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ltvToCac",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paybackMonths",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "size",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "month",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v12 = [
  (v10/*: any*/),
  (v11/*: any*/)
],
v13 = [
  (v8/*: any*/),
  (v9/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "MetricPoint",
    "kind": "LinkedField",
    "name": "points",
    "plural": true,
    "selections": (v12/*: any*/),
    "storageKey": null
  }
],
v14 = [
  (v8/*: any*/),
  (v7/*: any*/)
],
v15 = [
  {
    "kind": "Variable",
    "name": "from",
    "variableName": "from"
  },
  {
    "kind": "Variable",
    "name": "to",
    "variableName": "to"
  }
],
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v17 = [
  (v10/*: any*/),
  (v11/*: any*/),
  (v16/*: any*/)
],
v18 = [
  (v8/*: any*/),
  (v9/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "MetricPoint",
    "kind": "LinkedField",
    "name": "points",
    "plural": true,
    "selections": (v17/*: any*/),
    "storageKey": null
  },
  (v16/*: any*/)
],
v19 = [
  (v8/*: any*/),
  (v7/*: any*/),
  (v16/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "mrrPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UnitEconomics",
        "kind": "LinkedField",
        "name": "unitEconomics",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CohortCurve",
            "kind": "LinkedField",
            "name": "cohortCurves",
            "plural": true,
            "selections": (v13/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CohortRateCurve",
            "kind": "LinkedField",
            "name": "churnCohortCurves",
            "plural": true,
            "selections": (v13/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CohortRateCurve",
            "kind": "LinkedField",
            "name": "cacPaybackCohortCurves",
            "plural": true,
            "selections": (v13/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CohortRateCurve",
            "kind": "LinkedField",
            "name": "conversionCohortCurves",
            "plural": true,
            "selections": (v13/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CacPaybackSeries",
            "kind": "LinkedField",
            "name": "cacPaybackSeries",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MetricPoint",
                "kind": "LinkedField",
                "name": "punctual",
                "plural": true,
                "selections": (v12/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MetricPoint",
                "kind": "LinkedField",
                "name": "ttm",
                "plural": true,
                "selections": (v12/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CacPaybackCohorts",
            "kind": "LinkedField",
            "name": "cacPaybackCohorts",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CacPaybackCohort",
                "kind": "LinkedField",
                "name": "monthly",
                "plural": true,
                "selections": (v14/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CacPaybackCohort",
                "kind": "LinkedField",
                "name": "quarterly",
                "plural": true,
                "selections": (v14/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CacPaybackCohort",
                "kind": "LinkedField",
                "name": "yearly",
                "plural": true,
                "selections": (v14/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v15/*: any*/),
        "concreteType": "Mrr",
        "kind": "LinkedField",
        "name": "mrr",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "newMrr",
            "plural": true,
            "selections": (v12/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "expansionMrr",
            "plural": true,
            "selections": (v12/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "reactivationMrr",
            "plural": true,
            "selections": (v12/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "contractionMrr",
            "plural": true,
            "selections": (v12/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "churnedMrr",
            "plural": true,
            "selections": (v12/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "netNewMrr",
            "plural": true,
            "selections": (v12/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "endingMrr",
            "plural": true,
            "selections": (v12/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "smsRevenue",
            "plural": true,
            "selections": (v12/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "oneTimeRevenue",
            "plural": true,
            "selections": (v12/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "arpu",
            "plural": true,
            "selections": (v12/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "nrrTtm",
            "plural": true,
            "selections": (v12/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "grrTtm",
            "plural": true,
            "selections": (v12/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "quickRatio",
            "plural": true,
            "selections": (v12/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "activeCustomers",
            "plural": true,
            "selections": (v12/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "newCustomers",
            "plural": true,
            "selections": (v12/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "mrrPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UnitEconomics",
        "kind": "LinkedField",
        "name": "unitEconomics",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CohortCurve",
            "kind": "LinkedField",
            "name": "cohortCurves",
            "plural": true,
            "selections": (v18/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CohortRateCurve",
            "kind": "LinkedField",
            "name": "churnCohortCurves",
            "plural": true,
            "selections": (v18/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CohortRateCurve",
            "kind": "LinkedField",
            "name": "cacPaybackCohortCurves",
            "plural": true,
            "selections": (v18/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CohortRateCurve",
            "kind": "LinkedField",
            "name": "conversionCohortCurves",
            "plural": true,
            "selections": (v18/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CacPaybackSeries",
            "kind": "LinkedField",
            "name": "cacPaybackSeries",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MetricPoint",
                "kind": "LinkedField",
                "name": "punctual",
                "plural": true,
                "selections": (v17/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MetricPoint",
                "kind": "LinkedField",
                "name": "ttm",
                "plural": true,
                "selections": (v17/*: any*/),
                "storageKey": null
              },
              (v16/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CacPaybackCohorts",
            "kind": "LinkedField",
            "name": "cacPaybackCohorts",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CacPaybackCohort",
                "kind": "LinkedField",
                "name": "monthly",
                "plural": true,
                "selections": (v19/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CacPaybackCohort",
                "kind": "LinkedField",
                "name": "quarterly",
                "plural": true,
                "selections": (v19/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CacPaybackCohort",
                "kind": "LinkedField",
                "name": "yearly",
                "plural": true,
                "selections": (v19/*: any*/),
                "storageKey": null
              },
              (v16/*: any*/)
            ],
            "storageKey": null
          },
          (v16/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v15/*: any*/),
        "concreteType": "Mrr",
        "kind": "LinkedField",
        "name": "mrr",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "newMrr",
            "plural": true,
            "selections": (v17/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "expansionMrr",
            "plural": true,
            "selections": (v17/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "reactivationMrr",
            "plural": true,
            "selections": (v17/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "contractionMrr",
            "plural": true,
            "selections": (v17/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "churnedMrr",
            "plural": true,
            "selections": (v17/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "netNewMrr",
            "plural": true,
            "selections": (v17/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "endingMrr",
            "plural": true,
            "selections": (v17/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "smsRevenue",
            "plural": true,
            "selections": (v17/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "oneTimeRevenue",
            "plural": true,
            "selections": (v17/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "arpu",
            "plural": true,
            "selections": (v17/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "nrrTtm",
            "plural": true,
            "selections": (v17/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "grrTtm",
            "plural": true,
            "selections": (v17/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "quickRatio",
            "plural": true,
            "selections": (v17/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "activeCustomers",
            "plural": true,
            "selections": (v17/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "newCustomers",
            "plural": true,
            "selections": (v17/*: any*/),
            "storageKey": null
          },
          (v16/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "25965f3262f42e1e0b6922e9d5637d6a",
    "id": null,
    "metadata": {},
    "name": "mrrPage_Query",
    "operationKind": "query",
    "text": "query mrrPage_Query(\n  $from: String\n  $to: String\n) {\n  unitEconomics {\n    arpu\n    grossMarginTtm\n    monthlyRevenueChurnTtm\n    ltv\n    cacTtm\n    ltvToCac\n    paybackMonths\n    cohortCurves {\n      label\n      size\n      points {\n        month\n        value\n        id\n      }\n      id\n    }\n    churnCohortCurves {\n      label\n      size\n      points {\n        month\n        value\n        id\n      }\n      id\n    }\n    cacPaybackCohortCurves {\n      label\n      size\n      points {\n        month\n        value\n        id\n      }\n      id\n    }\n    conversionCohortCurves {\n      label\n      size\n      points {\n        month\n        value\n        id\n      }\n      id\n    }\n    cacPaybackSeries {\n      punctual {\n        month\n        value\n        id\n      }\n      ttm {\n        month\n        value\n        id\n      }\n      id\n    }\n    cacPaybackCohorts {\n      monthly {\n        label\n        paybackMonths\n        id\n      }\n      quarterly {\n        label\n        paybackMonths\n        id\n      }\n      yearly {\n        label\n        paybackMonths\n        id\n      }\n      id\n    }\n    id\n  }\n  mrr(from: $from, to: $to) {\n    newMrr {\n      month\n      value\n      id\n    }\n    expansionMrr {\n      month\n      value\n      id\n    }\n    reactivationMrr {\n      month\n      value\n      id\n    }\n    contractionMrr {\n      month\n      value\n      id\n    }\n    churnedMrr {\n      month\n      value\n      id\n    }\n    netNewMrr {\n      month\n      value\n      id\n    }\n    endingMrr {\n      month\n      value\n      id\n    }\n    smsRevenue {\n      month\n      value\n      id\n    }\n    oneTimeRevenue {\n      month\n      value\n      id\n    }\n    arpu {\n      month\n      value\n      id\n    }\n    nrrTtm {\n      month\n      value\n      id\n    }\n    grrTtm {\n      month\n      value\n      id\n    }\n    quickRatio {\n      month\n      value\n      id\n    }\n    activeCustomers {\n      month\n      value\n      id\n    }\n    newCustomers {\n      month\n      value\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "fac5d59e7918fdc0d4c52dd87e9524eb";

export default node;
